import { mapGetters } from "vuex";
import { formatRetryAfter } from "@/utils/retryAfter";

/**
 * Live countdown to the moment a throttled credential request may be retried.
 *
 * The store keeps only the absolute instant (see authfack.throttledUntil); the
 * ticking lives here so it starts and stops with the screen and never outlives
 * it. Screens use `throttleRetryAfter` to disable their submit button and
 * `retryCountdown` to show the remaining time.
 */
export const throttleCountdown = {
  data() {
    return {
      throttleNow: Date.now(),
      throttleTicker: null,
    };
  },
  computed: {
    ...mapGetters("authfack", ["throttledUntil"]),
    throttleRetryAfter() {
      if (!this.throttledUntil) return 0;

      return Math.max(0, Math.ceil((this.throttledUntil - this.throttleNow) / 1000));
    },
    retryCountdown() {
      return formatRetryAfter(this.throttleRetryAfter);
    },
  },
  created() {
    this.throttleTicker = setInterval(() => {
      this.throttleNow = Date.now();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.throttleTicker);
  },
};
